import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { getLang } from "./utils/utils";

const lang = getLang();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: "en",
    supportedLngs: ["en", "ru", "uz", "ar", "az", "es", "pt", "pl", "am", "hi"],
    backend: {
      loadPath: "/locales/{{lng}}/{{lng}}.json"
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: true }
  });

export default i18n;
